import { makeStyles } from '@material-ui/core'
import { FormControl, MenuItem, Select } from '@mui/material'
import { useEffect, useState } from 'react'
import FilterPopover from 'src/components/common/FilterPopover'
import { COLORS } from 'src/utils/Themes/colors'

const PolicyCitiesFilters = ({
  filters,
  applyFilters,
  citiesList,
  onCityChange,
}) => {
  const classes = useStyles()
  const defaultFilters = {
    city: null,
    count: null,
  }
  const [policyCitiesFilters, setPolicyCitiesFilters] = useState({
    ...defaultFilters,
  })

  useEffect(() => {
    if (filters) {
      setPolicyCitiesFilters((prevFilters) => ({
        ...prevFilters,
        city: filters?.city || '',
      }))
    }
  }, [filters])

  const handleFiltersChange = (event) => {
    setPolicyCitiesFilters((prevFilters) => ({
      ...prevFilters,
      [event.target.name]: event?.target?.value,
    }))

    if (event.target.name === 'city' && onCityChange) {
      onCityChange(event?.target?.value) // Notify parent component about city change
    }
  }

  const clearAllFilters = () => {
    setPolicyCitiesFilters({ ...defaultFilters })
    applyFilters({ ...defaultFilters })

    if (onCityChange) {
      onCityChange(null) // Reset city in parent component
    }
  }

  const handleFilters = () => {
    applyFilters({ city: policyCitiesFilters?.city || null })
  }

  return (
    <div className={classes.filterContainer}>
      <FilterPopover
        id='filterPopover'
        onClear={clearAllFilters}
        onApply={handleFilters}
      >
        <div>
          <div className={classes.formControlRow}>
            <div className={classes.formFilter}>
              <div className={classes.formControlContainer}>
                <span className={classes.formControlLabel}>City</span>
                <div className={classes.formControl}>
                  <FormControl fullWidth>
                    <Select
                      id='city'
                      name='city'
                      displayEmpty
                      value={policyCitiesFilters?.city || ''}
                      onChange={handleFiltersChange}
                      className={classes.selectTaskStatus}
                    >
                      <MenuItem
                        classes={{ root: classes.menuItemControl }}
                        value=''
                      >
                        <span className={classes.defaultMenuItem}>City</span>
                      </MenuItem>
                      {citiesList?.map((item, index) => (
                        <MenuItem key={index} value={item?.city}>
                          {item?.city} ({item?.count})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FilterPopover>
    </div>
  )
}

export default PolicyCitiesFilters

const useStyles = makeStyles({
  filterContainer: {
    float: 'right',
  },
  formControlRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  formControlContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  formFilter: {
    display: 'flex',
    gap: '10px',
  },
  formControlLabel: {
    fontSize: '12px',
    color: COLORS.GREY_12,
    fontWeight: '400',
  },
  formControl: {
    width: '100%',
  },
  menuItemControl: {
    width: '100% !important',
    padding: '5px 15px',
  },
  defaultMenuItem: {
    color: COLORS.GREY_12,
    fontStyle: 'italic',
  },
  menuItemControlSourceBy: {
    width: '100% !important',
    '& .MuiOutlinedInput-input': {
      borderRadius: '50px !important',
      height: '25px !important',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '4px',
    },
    '& .MuiInputBase-root': {
      borderRadius: '50px',
    },
  },
  selectTaskStatus: {
    '& .MuiInputBase-input': {
      borderRadius: '50px !important',
      height: '25px !important',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '4px',
    },
    borderRadius: '50px !important',
  },
})
